// js
import React, { Component } from 'react';
import { defaultPropTypes } from '../../containers/analytics/analyticsView';
import PropTypes from 'prop-types';
import OverlapTotalDataIndexed from './OverlapTotalDataIndexed';
import OverlapPercentageAnalysis from './OverlapPercentageAnalysis';
import OverlapAreaList from './OverlapAreaList';
// css
import '../../styles/components/analytics/Overlap.scss';


class Overlap extends Component {

  constructor(props) {
    super(props);
    this.state = this.getStateForSelectedArea(props);
    this.selectArea = this.selectArea.bind(this);
    this.isAreaEnabled = this.isAreaEnabled.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let newState = this.getStateForSelectedArea(nextProps);
    this.setState(newState);
  }

  getStateForSelectedArea(props) {
    let area = props.areas.find(a => a.id === parseInt(props.params.areaId));
    let overlapStatTotals = props.overlapStatTotals;
    return {
      selectedArea: area,
      percentTotal: overlapStatTotals[area.id].percentIndexed / 100,
      totalData: Number(overlapStatTotals[area.id].dataRequired),
      ciscoDataPerDay: Number(overlapStatTotals[area.id].ciscoDataPerDay),
      nonCiscoDataPerDay: Number(overlapStatTotals[area.id].nonCiscoDataPerDay),
      ciscoDataIndexed: Number(overlapStatTotals[area.id].ciscoDataIndexed),
      nonCiscoDataIndexed: Number(overlapStatTotals[area.id].nonCiscoDataIndexed),
      ciscoPercentIndexed: Number(overlapStatTotals[area.id].ciscoPercentIndexed),
      nonCiscoPercentIndexed: Number(overlapStatTotals[area.id].nonCiscoPercentIndexed)
    };
  }

  selectArea(area) {
    return () => {
      if (!this.isAreaEnabled(area)) return;
      const { baseNavRoute } = this.props;
      const route = `${baseNavRoute}/analytics/overlap/${area.id}`;
      this.props.router.push(route);
    };
  }

  isAreaEnabled(area) {
    return this.props.dsa.dsaAreas.find( aa => aa.area === area.id ).active;
  }

  render() {
    const {areas, dsa, overlapStats} = this.props;

    return (
      <div className='analytics__overlap-content box'>
        <h2>Quick Analysis: {this.state.selectedArea.title}</h2>
        <p className='analytics__description'>Choose an assessment center below to see how much data is currently being indexed by Splunk. The overlaps to the left show the percentage of total data being indexed by center with data sources in common.</p>
        <div id={this.props.pptxTarget} className='analytics__overlap-content box'>
          <div className='overlapping-analysis-form'>
            <div className='row'>
              <div className='col-md-4'>
                <OverlapTotalDataIndexed
                  areaTitle={this.state.selectedArea.title}
                  percentTotal={this.state.percentTotal}
                  totalData={this.state.totalData}
                  ciscoDataPerDay={this.state.ciscoDataPerDay}
                  nonCiscoDataPerDay={this.state.nonCiscoDataPerDay}
                  ciscoDataIndexed={this.state.ciscoDataIndexed}
                  nonCiscoDataIndexed={this.state.nonCiscoDataIndexed}
                  ciscoPercentIndexed={this.state.ciscoPercentIndexed}
                  nonCiscoPercentIndexed={this.state.nonCiscoPercentIndexed}
                />
              </div>
              <div className='col-md-4'>
                <OverlapPercentageAnalysis
                  isAreaEnabled={this.isAreaEnabled}
                  dsa={dsa}
                  stats={overlapStats}
                  selectedArea={this.state.selectedArea}
                  areas={areas}
                />
              </div>
              <div className='col-md-4'>
                <OverlapAreaList
                  areas={areas}
                  selectedArea={this.state.selectedArea}
                  isAreaEnabled={this.isAreaEnabled}
                  onSelectArea={this.selectArea}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Overlap.propTypes = {
  ...defaultPropTypes,
  pptxTarget: PropTypes.string
};

export default Overlap;



// WEBPACK FOOTER //
// ./src/components/analytics/Overlap.js